export const IGNORED_WL_PATHS = ['/health-check', '/community/health-check', '/api/health-check']
